module.exports = __webpack_public_path__ + "img/pr-1.99258954.png";